
import React, { Component } from 'react'
import axios from 'axios'
import { NotificationManager } from 'react-notifications'
const url = window.location.href;
const params = (new URL(url)).searchParams;
const id = params.get("productid");
const token = localStorage.getItem("token");
const type = localStorage.getItem("type");
const loggedInUserID = parseInt(localStorage.getItem("loggedInUserID"));
class DeleteProduct extends Component {
	constructor(props) {
		super(props)

	}

	changeHandler = e => {
		this.setState({ [e.target.name]: e.target.value })
	}



	submitHandler = e => {
		e.preventDefault()
		console.log(this.state)
        const requestBody = {
            // getting user input 
            userid: loggedInUserID,
          };
		axios
			.delete(`https://shoppee-clone.herokuapp.com/products/${id}/`, requestBody,  {
                headers: { 'Content-Type': 'application/json' }
              })
			.then(response => {
				console.log(response)
				window.location.reload()
			})
			.catch(error => {
				NotificationManager.error('error deleting');
				console.log(error)
			})
	}

	render() {
		if (type === "boss" && token != null) {
			return (
				<div>
				<fieldset class="w-100 col-12 mt-5 d-flex justify-content-around">
				<form  onSubmit={this.submitHandler} action="" method="delete">
				  <button class="btn btn-danger button2" id="checkingout">
				   Delete this product <i class="bi bi-x"></i>
				  </button>
			  </form>
			  </fieldset>
			  </div>
			  
			)
		}
		
	}
}

export default DeleteProduct;

